import { NavLink, Link } from 'react-router-dom';
import './navbar.css';

function linkClassName({ isActive }) {
  return `link${isActive ? ' active' : ''}`;
}

export function Navbar() {
  return (
    <header className="nav">
      <div className="container navInner">
        <Link to="/" className="brand" aria-label="العودة للصفحة الرئيسية">
          <img
            className="brandLogo"
            src="https://graph.facebook.com/ElfahmawiBoxingCenter/picture?type=large"
            alt="شعار مركز الملاكمة الفحماوي"
            loading="lazy"
          />
          <div className="brandText">
            <div className="brandTitle">مركز الملاكمة الفحماوي</div>
            <div className="brandTagline">قوة • لياقة • انضباط</div>
          </div>
        </Link>

        <nav className="links" aria-label="التنقل الرئيسي">
          <NavLink to="/" className={linkClassName} end>
            من نحن
          </NavLink>
          <NavLink to="/ain-khaled" className={linkClassName}>
            عين خالد
          </NavLink>
          <NavLink to="/al-maydan" className={linkClassName}>
            الميدان
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

